import "babel-polyfill";
import React, { useEffect, useState } from "react";
import { HashRouter as Router } from "react-router-dom";
import { Route, Redirect, Switch } from "react-router-dom";
import asyncComponent from "./services/async.component";
import Translations from "./services/translation.service";
import Helpers from "./helpers/shared.helper";
import Storage from "./services/storage.service";
import User from "./services/user.service";
import Flow from "./services/flow.service";
import Message from "./views/shared/message.component";
import "./App.css";
import GTMService from "./services/gtm.service";
import Products from "./services/products.service";
import HTTP from "./services/http.service";
import Settings from "./services/settings.service";
import createHistory from "history/createBrowserHistory";
import OcrOptionType from "./views/ocr/ocr_option_type";
import ScanId from "./views/paci/scan-id.component";
import PaciConnection from "./views/paci/paci-connection.component";
import DropOffModal from "./views/dropOff/dropOffModal";
import DropOff from "./views/dropOff";
import AlmostDone from "./views/delivery/almost-done";
import DeliveryInProgress from "./ui/delivery_in_progress";
import EligibilityCheckUI from "./ui/eligibility_check";
import StorefrontHeader from "./views/shared/storefront-header.component";
import ScreenLoader from "./views/shared/screen-loader.component";
import ProgressBar from "./views/shared/progressBar";
import FirebaseAnalytics from "./services/analytics.service";
import STF_CONSTANTS from "./services/stfConstant.service";
import storefront from "./services/storefront.service";
import Activation from "./services/activation.service";
import Advertisement from "./ui/advertisement";
import FooterWrapper from "./views/shared/footer-wrapper.component";
import Common from "./services/common.service";
import ContentServiceModal from "./views/planSelection/content-service";
// import MNPKWForm from "./ui/mnp_form";
// import MNPOTP from "./ui/mnp_otp";
// import MNPBalanceUI from "./ui/mnp_outstanding";
import SpinnerTimeLoader from "./views/shared/timeLoading";
import PaymentSuccess from "./views/payment/payment-success";
import PaymentFailure from "./views/payment/payment-failure";
import PaciQR from "./views/paci/paci-qr.component";

const history = createHistory({
  basename: "", // The base URL of the app (see below)
  hashType: "hash", // The hash type to use (see below)
});

const AsyncReceiveToken = asyncComponent(() => {
  return import("./views/payment/receive-token.component");
});

const AsyncConfirmation = asyncComponent(() => {
  return import("./views/payment/confirmation.component");
});

const AsyncApplyPayConfirmationTopup = asyncComponent(() => {
  return import("./views/topUp/top-up-success");
});

const AsyncApplyPayFailureTopup = asyncComponent(() => {
  return import("./views/topUp/top-up-failed");
});

const AsyncPayment = asyncComponent(() => {
  return import("./ui/add_cc");
});

// const AsyncApplePayConfirmationOb = asyncComponent(() => {
//   return import("./views/payment/confirmation-apple-pay.component");
// });

// const AsyncApplePayFailedOb = asyncComponent(() => {
//   return import("./views/payment/confirmation-apple-pay-failed.component");
// });

const AsyncAbsherValidation = asyncComponent(() => {
  return import("./views/absher/absher-validation.component");
});

const AsyncDelivery = asyncComponent(() => {
  return import("./ui/sim_delivery");
});

const AsyncSimDeactivation = asyncComponent(() => {
  return import("./ui/sim_deactivation");
});

const AsyncProtectionChannel = asyncComponent(() => {
  return import("./ui/protection_channel");
});

let userSelectionSet = false;
let populatedImports = false;
let userSelectionCheck = false;
const import_list = {};
const App = () => {
  const [route, setRoute] = useState(null);
  const [routes, setRoutes] = useState(null);
  const [translations_loaded, setTranslationLoaded] = useState(false);
  // const [wp_loader, setWpLoaded] = useState(false);
  // const [classes, setClasses] = useState("");
  // const [mnpNumber, setMnpNumber] = useState("");
  const [error, setError] = useState(null);
  const [direction, setDirection] = useState(null);
  const [dropOffJourney, setDropOffJourney] = useState(
    localStorage.getItem("TabSwitched")
  );
  const [dropOffJourneyVisibility, setDropOffJourneyVisibility] =
    useState(false);
  const [dropOffTime, setDropOffTime] = useState("");
  const prefix = "";

  useEffect(() => {
    // KW 
    if (Helpers.isWWW()) {
      Helpers.isWWW();
    }
    //----
    const scriptTapCdn = document.createElement("script");
    scriptTapCdn.src = Settings.tap_cdn_source;
    scriptTapCdn.async = true;
    scriptTapCdn.type = "text/javascript";
    const scriptTapSdk = document.createElement("script");
    scriptTapSdk.src = Settings.tap_sdk_source;
    scriptTapSdk.type = "text/javascript";
    scriptTapSdk.async = true;
    document.body.appendChild(scriptTapCdn);
    document.body.appendChild(scriptTapSdk);

    return () => {
      document.body.removeChild(scriptTapCdn);
      document.body.removeChild(scriptTapSdk);
    };
  }, []);

  useEffect(() => {
    const getTheme = () => {
      let theme = JSON.parse(Storage.get("theme", true));
      if (theme) {
        //Set the two dates
        let y2k = Date.parse(new Date(theme["created_at"]));
        let today = Date.parse(new Date());
        // let today= Date.parse("Feb 25, 2019");

        if (
          Helpers.dateDiff("n", y2k, today) + 1 >
          Settings["data_expiry_duration"] ||
          Settings["theme_version"] !== theme["version"]
        ) {
          fetchingTheme();
        }
      } else {
        fetchingTheme();
      }
    };
    User.init();
    GTMService.init();
    //ksa
    Activation.init();
    getTheme();
    Flow.getPOSettings();
  }, []);

  useEffect(() => {
    const populateImports = () => {
      let uis_to_import = Flow.get("uis_to_import");
      let routes = [];
      for (let ui_component of uis_to_import) {
        if (!import_list[ui_component]) {
          import_list[ui_component.path] = asyncComponent(() =>
            import("./ui/" + ui_component.name)
          );
        }
      }

      for (let route of Object.keys(import_list)) {
        routes.push(
          <Route
            path={"/" + route.substr(prefix.length)}
            exact
            key={route}
            component={import_list[route]}
          />
        );
      }

      setRoutes(routes);
      populatedImports = true;
    };

    Flow.get_obsrv("flow_loaded").subscribe((data) => {
      if (data) {
        Storage.get_obsrv("session").subscribe((data) => {
          if (data) {
            User.goToStatusRoute();
            Products.fetchAllowedFeatures();
          } else {
            User.checkUser();
          }
        });

        Storage.get_obsrv("error").subscribe((data) => {
          setError(data);
          // this.setState({
          //   error: data
          // });
        });

        Storage.get_obsrv("flags").subscribe((data) => {
          if (data) {
            if (!Helpers.exceptionParamsExist()) {
              if (userSelectionSet) {
                Flow.goTo(Flow.get("root_id"));
                return;
              }
              if (!populatedImports) populateImports();
              userSelectionCheck = true;
              Flow.goTo(Flow.get("root_id"));
              userSelectionSet = true;
              // Storage.getOrfetch("vanity_details", Numbers.vanity_details)
              //   .then((dataVanity) => {
              //     if (dataVanity["data"]) {
              //       Numbers.process_vanity_details(dataVanity.data);
              //       if (!populatedInports) populateImports();

              //       userSelectionCheck = true;
              //       Flow.goTo(Flow.get("root_id"));
              //       userSelectionSet = true;

              //       // Store the Vanity IDs
              //       let vainity_id = [];
              //       for (let vanity of dataVanity?.data) {
              //         if (vanity?.VanityID || vanity?.VanityID === 0) {
              //           vainity_id.push(vanity.VanityID)
              //         }
              //       }
              //       vainity_id = vainity_id?.length ? vainity_id?.sort() : vainity_id;
              //       Storage.set("vainity_id", vainity_id.toString());

              //     }
              //   })
              //   .catch((error) => { });
            } else {
              if (!populatedImports && !userSelectionCheck) populateImports();
              if (Helpers.receiverPagesExist()) {
                if (window.location.href.indexOf("confirmation") !== -1) {
                  // Do Nothing
                  if (!Storage.get("visitedConfirmation")) {
                    Storage.set("visitedConfirmation", true);
                    Flow.goTo();
                  }

                } else {
                  Flow.goTo();
                }
              } else {
                Helpers.log("found exception path");
                Flow.goTo();
              }
            }
          }
        });
      }
    });

    return () => {
      return () => {
        userSelectionSet = false;
      };
    };
  }, []);

  useEffect(() => {
    Flow.get_obsrv("current").subscribe((data) => {
      let route = null;
      if (data) {
        if (data["web_pathname"]) {
          Storage.set("Page_name", data["web_pathname"]);
        }

        let path = data["web_pathname"] ? data["web_pathname"] : data["name"];
        if (!path) {
          path = data;
        }
        route = <Redirect key={path + Date.now().toString()} to={"/" + path} />;

        if (Settings.enable_history) {
          if (data && history.location.hash !== "#" + path) {
            history.push("#" + path);
          }
        }
        setRoute(route);
      }
    });
  }, []);

  useEffect(() => {
    Translations.getTranslations(Translations.activeLang);

    Translations.getTranslationsObsrv().subscribe((data) => {
      if (Translations.activeLang === "ar") {
        loadCSSByDirection("RTL");
      } else {
        loadCSSByDirection("LTR");
      }

      if (data) {
        setTranslationLoaded(true);
        // let additional = {
        // ob_mnp_terms_compliance_point2:
        //   "Any material which is defamatory, offensive or of an obscene character.",
        // };
        // Translations.setAdditonalKeysTesting(additional);
      }
    });
  }, []);

  useEffect(() => {
    if (window.location.href.indexOf("paci") === -1 && window.location.href.indexOf("mnp") === -1 && window.location.href.indexOf("scan") === -1) {
      window.addEventListener("beforeunload", handleUnload);
      if (!localStorage.getItem("WelcomeBack")) {
        window.addEventListener("visibilitychange", handleSwitchTab);
      }
      return () => {
        window.removeEventListener("beforeunload", handleUnload);
        window.removeEventListener("visibilitychange", handleSwitchTab);
      };
    }
  }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUnload = (e) => {
    sessionStorage.setItem("reloaded", true);
    localStorage.setItem("ReloadedOrLeft", true);
  };

  const handleSwitchTab = () => {
    if (window.location.href.indexOf("paci") === -1 && window.location.href.indexOf("scan") === -1) {
      let flag = Storage.get("flags");
      if (
        document.visibilityState === "hidden" &&
        !localStorage.getItem("ReloadedOrLeft") &&
        flag?.PaymentPending
      ) {
        localStorage.setItem("TabSwitched", true);
        setDropOffTime(new Date());
        setDropOffJourney(true);
      }
      if (
        document.visibilityState === "visible" &&
        !localStorage.getItem("ReloadedOrLeft") &&
        flag?.PaymentPending
      ) {
        sessionStorage.setItem("TabSwitchedBack", true);
        setDropOffTime(new Date());
        setDropOffJourneyVisibility(true);
      }
      if (window.location.href.indexOf("category") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("random") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("number") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("mnp") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("pay") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("paci") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("scan") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
      if (window.location.href.indexOf("confirmation") > 1) {
        setDropOffJourney(false);
        setDropOffJourneyVisibility(false);
        setDropOffTime("");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        return;
      }
    }
  };

  useEffect(() => {
    Storage.get_obsrv("flags").subscribe((data) => {
      if (data) {
        let flag = data;
        if (
          sessionStorage.getItem("reloaded") === "true" &&
          localStorage.getItem("ReloadedOrLeft") === "true"
        ) {
          sessionStorage.removeItem("reloaded");
          localStorage.removeItem("ReloadedOrLeft");
        } else if (localStorage.getItem("ReloadedOrLeft") === "true") {
          if (
            (window.location.href.substr(-3) !== "/#/" ||
              window.location.href.indexOf("random") === -1 ||
              window.location.href.indexOf("number") === -1 ||
              window.location.href.indexOf("mnp") === -1) &&
            flag?.PaymentPending
          ) {
            localStorage.setItem("WelcomeBack", true);
            setDropOffJourney(false);
            setDropOffJourneyVisibility(false);
            setDropOffTime("");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
          }
          if (window.location.href.indexOf("random") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("number") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("mnp") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("activation-success") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (!flag?.PaymentPending) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
        }
      }
    });
  }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    // let contentList = Storage.get("contentServiceList", true, true);
    // if (contentList) {
    //   let contenServicetList = JSON.parse(contentList);
    //   Storage.set("contentServiceList", contenServicetList);
    // }
    let wpData = window.localStorage.getItem("user_selection");
    let storage_params = wpData ? JSON.parse(wpData) : "";
    let fullImageBanner = window.localStorage.getItem("full_image_banner");

    if (storage_params) {
      if (storage_params["plan_ids"] || storage_params["bundle_id"] || storage_params["plan_type"]) {
        if (storage_params["plan_ids"] || storage_params["bundle_id"] || storage_params["plan_type"]) {
          if (storage_params["plan_type"] === "CUS" || storage_params["plan_type"] === "PRD" || storage_params["plan_type"] === "PRD-FG") {
            Storage.set("is_web_category_selected", true, true);
            Storage.set("choose_plan_category", true, true);
            if (storage_params["product_code"]) {
              Storage.set("pre-defined-plan-selected-product-code", storage_params["product_code"], true); 
            }
            if (storage_params["plan_type"] === "PRD-FG") {
              Storage.set("is_category_type_5g", true, true)
            }
            if (storage_params["plan_type"] === "PRD" || storage_params["plan_type"] === "PRD-FG") {
              Storage.set("skip_plan_selection",true)
              User.fetchFlowStatus();
            } else if (storage_params["plan_type"] === "CUS") {
              Storage.set("skip_plan_selection", true)
              Storage.set("is_web_category_selected", true, true);
              Storage.set("choose_plan_category", true, true);
              Storage.set("is_custom_card_selected", true, true);
              Storage.set("plan_type", storage_params["plan_type"], true);
              User.fetchFlowStatus();
            }
          }
        }
      }
      let vanity_data = storage_params["vanity_level"]
      if (vanity_data ||
        Number(vanity_data) === 0) {
        let vanityId = vanity_data === "0" ? vanity_data.toString() : Number(vanity_data);
        Storage.set("active_search_vanity", vanityId);
        Storage.clear("number_detail_ob");
        Storage.set("web_search_more_number", true, true);
        Storage.set("is_web_category_selected", true, true);
        Storage.clear("user_selection")
        User.fetchFlowStatus();
      }
    }
    if (storage_params["chose_mnp"]) {
      Storage.set("chose_mnp", true, true);
      User.fetchFlowStatus();

    }
    if (storage_params["start_search"]) {
      Storage.set("is_web_category_selected", true, true);
      Storage.set("web_search_more_number", true, true);
      Storage.clear("start_search");
      User.fetchFlowStatus();
    }
    if (storage_params && storage_params["MSISDN"]) {
      Storage.set("random_number", { MSISDN: storage_params["MSISDN"] });
      Storage.set("web_random_number_skip", true, true);
      Storage.set("is_web_category_selected", true, true);
      delete storage_params["MSISDN"];
      Storage.set("user_selection", JSON.stringify(storage_params), true);
      User.fetchFlowStatus();
    }

    if (Storage.get("choose_topup_category") !== true &&
      window.location.href.includes("top_up")) {
      Storage.set("choose_topup_category", true, true);
      Storage.set("is_web_category_selected", true, true);
      User.fetchFlowStatus();
    }

    if (fullImageBanner) {
      if (
        fullImageBanner === STF_CONSTANTS.CTA_BRING_YOUR_NUMBER ||
        fullImageBanner === STF_CONSTANTS.CTA_GENERATE_NOW ||
        fullImageBanner === STF_CONSTANTS.CTA_VIEW_ALL
      ) {
        storefront.selectCategory(fullImageBanner);
      } else {
        if (fullImageBanner === STF_CONSTANTS.CTA_CUSTOMIZE_PLAN) {
          storefront.selectCustomPlan();
        } else if (
          fullImageBanner === STF_CONSTANTS.CTA_PLAN_SELECTION_TAP ||
          fullImageBanner === STF_CONSTANTS.CTA_PLAN_CARD_TAP ||
          fullImageBanner === STF_CONSTANTS.CTA_PLAN_LIST_TAP
        ) {
          storefront.selectPlan();
        }
      }
      localStorage.removeItem("full_image_banner");
    }
  }, [])

  const fetchingTheme = () => {
    Storage.set("themeLoading", true);
    let config = {
      method: "get",
      url: "/graphs/theme",
    };
    HTTP(config)
      .then((themeVariable) => {
        Common.setThemeValues(themeVariable)
      })
      .catch((error) => {
        Storage.set("themeLoading", false);
      });
  };

  const loadCSSByDirection = (dir) => {
    setDirection(dir);
  };
  let redirection = null;
  if (route) {
    redirection = route;
  }

  let content = <SpinnerTimeLoader />;
  let errorMessage = "";
  let router_switch = "";

  if (translations_loaded) {
    if (Settings?.firebase_analytics_configs) {
      FirebaseAnalytics.init();
    }
    if (routes) {
      content = routes;
    } else {
  
    }

    router_switch = (
      <Switch>
        {content}
        <Route
          path="/payfort_token"
          key={"/payfort_token" + Date.now()}
          exact
          component={AsyncReceiveToken}
        />
        <Route
          path="/scan-qr-code"
          key={"/scan-qr-code" + Date.now()}
          exact
          component={(props) => <AlmostDone history={props.history} />}
        />
        <Route
          path="/confirmation-apple"
          key={"/confirmation-apple" + Date.now()}
          exact
          component={() => <PaymentSuccess />}
        />

        <Route
          path="/apple-pay-failure"
          key={"/apple-pay-failure" + Date.now()}
          exact
          component={() => <PaymentFailure />}
        />
        <Route
          path="/confirmation"
          key={"/confirmation" + Date.now()}
          exact
          component={AsyncConfirmation}
        />
        {/* <Route
          path="/confirmation-apple-onboarding"
          key={"/confirmation-apple-onboarding" + Date.now()}
          exact
          component={AsyncApplePayConfirmationOb}
        /> */}
        {/* <Route
          path="/apple-pay-failure-onboarding"
          key={"/apple-pay-failure-onboarding" + Date.now()}
          exact
          component={AsyncApplePayFailedOb}
        /> */}
        <Route
          path="/absher-validation"
          key={"/absher-validation" + Date.now()}
          exact
          component={AsyncAbsherValidation}
        />
        <Route
          path="/delivery"
          key={"/delivery" + Date.now()}
          exact
          component={AsyncDelivery}
        />
        <Route
          path="/sim-deactivation"
          key={"/sim-deactivation" + Date.now()}
          exact
          component={AsyncSimDeactivation}
        />
        <Route
          path="/protection-channel"
          key={"/protection-channel" + Date.now()}
          exact
          component={AsyncProtectionChannel}
        />
        <Route
          path="/advertisement"
          key={"/advertisement" + Date.now()}
          exact
          component={(props) => (
            <Advertisement history={props.history} flow="number" />
          )}
        />
        <Route
          path="/advertisement/otp/"
          key={"/advertisement/otp/" + Date.now()}
          exact
          // component={AsyncAdvertisementOptions}
          component={(props) => (
            <Advertisement history={props.history} flow={"otp"} />
          )}
        />
        <Route
          path="/payment"
          key={"/payment" + Date.now()}
          exact
          component={AsyncPayment}
        />
        <Route
          path="/scan/kuwaitID"
          key={"/scan/kuwaitID" + Date.now()}
          exact
          component={(props) => <ScanId history={props.history} />}
        />

        <Route
          path="/scan/PaciQR"
          key={"/scan/PaciQR" + Date.now()}
          exact
          component={(props) => <PaciQR history={props.history} />}
        />

        <Route
          path="/scan/id"
          key={"/scan/id" + Date.now()}
          exact
          component={(props) => (
            <OcrOptionType history={props.history} type="kw_id" />
          )}
        />
        <Route
          path="/eligibility"
          key={"/eligibility" + Date.now()}
          exact
          component={(props) => <EligibilityCheckUI history={props.history} />}
        />
        <Route
          path="/scan/passport_gcc"
          key={"/scan/passport_gcc" + Date.now()}
          exact
          component={(props) => (
            <OcrOptionType history={props.history} type="kw_passport_gcc" />
          )}
        />

        <Route
          path="/paci/connection"
          key={"/paci/connection" + Date.now()}
          exact
          component={(props) => <PaciConnection history={props.history} />}
        />
        {/* <Route
          path="/store-activation"
          key={"/store-activation" + Date.now()}
          exact
          component={(props) => <StoreActivation history={props.history} />}
        /> */}
        <Route
          path="/delivery-inprogress"
          key={"/delivery-inprogress" + Date.now()}
          exact
          component={(props) => <DeliveryInProgress history={props.history} />}
        />

        <Route
          path="/scan-qr-code"
          key={"/scan-qr-code" + Date.now()}
          exact
          component={(props) => <AlmostDone history={props.history} />}
        />
        {/* <Route
          path="/esim-qr"
          key={"/esim-qr" + Date.now()}
          exact
          component={(props) => <EsimQRCode history={props.history} />}
        /> */}
        <Route
          path="/confirmation-apple-top-up"
          key={"/confirmation-apple-top-up" + Date.now()}
          exact
          component={AsyncApplyPayConfirmationTopup}
        />

        <Route
          path="/apple-pay-top-up-failure"
          key={"/apple-pay-top-up-failure" + Date.now()}
          exact
          component={AsyncApplyPayFailureTopup}
        />
        {/* <Route
          path="/confirmation-apple-onboarding"
          key={"/confirmation-apple-onboarding" + Date.now()}
          exact
          component={AsyncApplePayConfirmationOb}
        /> */}
        {/* <Route
          path="/apple-pay-failure-onboarding"
          key={"/apple-pay-failure-onboarding" + Date.now()}
          exact
          component={AsyncApplePayFailedOb}
        /> */}
        <Route
          path="/absher-validation"
          key={"/absher-validation" + Date.now()}
          exact
          component={AsyncAbsherValidation}
        />
        <Route
          path="/delivery"
          key={"/delivery" + Date.now()}
          exact
          component={AsyncDelivery}
        />
        <Route
          path="/sim-deactivation"
          key={"/sim-deactivation" + Date.now()}
          exact
          component={AsyncSimDeactivation}
        />
        <Route
          path="/protection-channel"
          key={"/protection-channel" + Date.now()}
          exact
          component={AsyncProtectionChannel}
        />
        <Route
          path="/advertisement"
          key={"/advertisement" + Date.now()}
          exact
          component={(props) => <Advertisement history={props.history} flow="number" />}

        />
        <Route
          path="/advertisement/otp/"
          key={"/advertisement/otp/" + Date.now()}
          exact
          // component={AsyncAdvertisementOptions}
          component={(props) => <Advertisement history={props.history} flow={"otp"} />}
        />

        {/* // Commented MNP Enet Starts here */}
        {/* {Settings.version === "_kw_onboard" ?
          <>
            <Route
              path="/mnp"
              key={"/mnp" + Date.now()}
              exact
              component={(props) => <MNPKWForm history={props.history} />}
            />

            <Route
              path="/mnp/otp"
              key={"/mnp/otp" + Date.now()}
              exact
              component={(props) => <MNPOTP history={props.history} />}
            />
            
            <Route
              path="/mnp/balance"
              key={"/mnp/balance" + Date.now()}
              exact
              component={(props) => <MNPBalanceUI history={props.history} />}
            />
          </> : null
        } */}
        {/* // Commented MNP Enet Ends here */}

      </Switch>
    );

    if (error) {
      if (error === "error_email_not_found" ||
        error === "error_unsupported_delivery_location" ||
        error === "error_delivery_unavailable"
      ) {
        errorMessage = <Message error={error} action={() => {
          Storage.set("delivery_status", null);
          Flow.goTo();
        }} />;
      } else {
        errorMessage = <Message error={error} />;
      }

      router_switch = "";
    }
  }

  const closeDropOffScreen = () => {
    setDropOffJourney(false);
  };

  return (
    <Router>
      {/* <div className='font-change'> */}
      <div>
        <div
          dir={direction}
          className={
            "wrapper oct " +
            // classes +
            " " +
            direction
          }
        >
          <ScreenLoader />
          <StorefrontHeader />
          <ProgressBar />
          <main className="kwonboardapp_main">
            {dropOffJourney &&
              !errorMessage &&
              localStorage.getItem("is_category_type_5g") === "false" &&
              window.location.href.indexOf("search-number") === -1 &&
              window.location.href.indexOf("activation-inprogress") === -1 &&
              window.location.href.indexOf("activation-failed") === -1 &&
              window.location.href.indexOf("activated") === -1 &&
              window.location.href.indexOf("store-pickup") === -1 &&
              window.location.href.indexOf("delivery") === -1 &&
              window.location.href.indexOf("absher-validation") === -1 &&

              window.location.href.substr(-3) !== "/#/" &&
              window.location.href.indexOf("random") === -1 &&
              window.location.href.indexOf("scan-sim") === -1 &&
              window.location.href.indexOf("scan") === -1 &&
              window.location.href.indexOf("number") === -1 &&
              window.location.href.indexOf("category") === -1 &&
              window.location.href.indexOf("plan") === -1 &&
              window.location.href.indexOf("mnp") === -1 &&
              window.location.href.indexOf("pay") === -1 &&
              window.location.href.indexOf("top_up") === -1 &&
              window.location.href.indexOf("confirmation") === -1 &&
              
              sessionStorage.getItem("TabSwitchedBack") === "true" ? (
              <DropOff
                closeDropOffScreen={() => closeDropOffScreen()}
                tabState={dropOffJourneyVisibility}
                dropOffTime={dropOffTime}
              />
            ) : (
              <>
                {router_switch}
                {redirection}
              </>
            )}
            {/* <>
              {router_switch}
              {redirection}
            </> */}
            {errorMessage}
            {localStorage.getItem("WelcomeBack") &&
              localStorage.getItem("is_category_type_5g") === "false" &&
              window.location.href.indexOf("category") === -1 &&
              window.location.href.indexOf("search-number") === -1 &&
              window.location.href.indexOf("activation-inprogress") === -1 &&
              window.location.href.indexOf("activation-failed") === -1 &&
              window.location.href.indexOf("activated") === -1 &&
              window.location.href.indexOf("store-pickup") === -1 &&
              window.location.href.indexOf("delivery") === -1 &&
              window.location.href.indexOf("absher-validation") === -1 &&
              window.location.href.indexOf("confirmation") === -1 &&
              window.location.href.substr(-3) !== "/#/" &&
              window.location.href.indexOf("random") === -1 &&
              window.location.href.indexOf("number") === -1 &&
              window.location.href.indexOf("mnp") === -1 &&
              window.location.href.indexOf("scan-sim") === -1 &&
              window.location.href.indexOf("scan") === -1 &&
              window.location.href.indexOf("plan") === -1 &&
              window.location.href.indexOf("activation-success") === -1 && (
                <DropOffModal history={history} />
              )}
          </main>
          {<ContentServiceModal />}
          <FooterWrapper />
        </div>
      </div>
    </Router>
  );
};

export default App;
